import { render, staticRenderFns } from "./MealOrdering.vue?vue&type=template&id=21e3b128&"
import script from "./MealOrdering.vue?vue&type=script&lang=js&"
export * from "./MealOrdering.vue?vue&type=script&lang=js&"
import style0 from "./MealOrdering.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports